import { createStore,compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import reducers from "../reducers";

import { persistStore, persistReducer } from 'redux-persist';

import storage from "redux-persist/lib/storage";

const persistConfig = {
    key: "appName",
    storage,
    whitelist: ['perstistorReducer']
}

const persistedReducer = persistReducer(persistConfig, reducers);

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    persistedReducer,
    composeEnhancer(applyMiddleware(thunk))
);

export default store;
export const persistor = persistStore(store);